export const AUTH_LIMITS = Object.freeze({
  name: 20,
  email: 50,
  password: 20,
  referralCode: 20,
  verificationCode: 6,
  resetCode: 6,
});

export function sanitizeAuthField(name, value) {
  const nextValue = String(value ?? "");

  switch (name) {
    case "name":
      return nextValue.slice(0, AUTH_LIMITS.name);
    case "email":
      return nextValue.slice(0, AUTH_LIMITS.email);
    case "password":
    case "newPassword":
      return nextValue.slice(0, AUTH_LIMITS.password);
    case "sponsorCode":
      return nextValue.slice(0, AUTH_LIMITS.referralCode);
    case "otp":
      return nextValue.replace(/\D/g, "").slice(0, AUTH_LIMITS.verificationCode);
    case "code":
      return nextValue.replace(/\D/g, "").slice(0, AUTH_LIMITS.resetCode);
    default:
      return nextValue;
  }
}

export function normalizeEmail(value) {
  return sanitizeAuthField("email", value).trim();
}

export function hasValidEmailFormat(value) {
  const email = normalizeEmail(value);

  if (!email) return false;

  if (typeof document !== "undefined") {
    const input = document.createElement("input");
    input.type = "email";
    input.required = true;
    input.value = email;
    return input.checkValidity();
  }

  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}
